export default __webpack_public_path__ + "static/GRID2022 Stock IDPs0-24 RGBlight - Simplify-01-sp-ad22712c6ee67046d60eb2b49b95a9a1.svg";